export default __webpack_public_path__ + "static/media/erik-lucatero-2.d09715ab.jpg";